import { BlurOn } from "@mui/icons-material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

import { DragRideRowIconReplacement } from "../cells.ride.styled";

/** Keeps BlurOn and the 12px map circle in the same horizontal slot (no shift on select). */
export const IndicatorSlot = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "live-map-color-indicator-slot",
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
`;

export const ClickableColorCircle = styled(DragRideRowIconReplacement)`
  cursor: pointer;
`;

/** Same icon as grid single-select row "pick on map" (`cell-multi-icon.drag-or-select-handle`). */
export const LiveMapUnselectedDotsIcon = styled(
  BlurOn,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "live-map-color-indicator-grid",
})`
  color: ${blueGreyMui._400};
  cursor: pointer;
  flex-shrink: 0;
  font-size: 22px;
`;
